import { ChapterTitle } from '../elements/atoms/chapterTitle/ChapterTitle';
import { PageTitle } from '../elements/atoms/pageTitle/PageTitle';
import { Paragraph } from '../elements/atoms/paragraph/Paragraph';
import { Article } from '../elements/molecules/article/article';
import { Container } from '../elements/molecules/container/Container';
import { Main } from '../elements/molecules/main/Main';
import { PageSection } from '../elements/molecules/pageSection/PageSection';
import { Footer } from '../elements/organisms/footer/Footer';
import { Header } from '../elements/organisms/header/Header';
import { PageWrapper } from '../elements/organisms/pageWrapper/PageWrapper';

export function OverKsyos() {
    return (
        <PageWrapper fullHeight>
            <Header hasBackbutton />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Over Ksyos</PageTitle>
                        </Article>
                    </PageSection>
                    <PageSection bgColor="white">
                        <Article>
                            <ChapterTitle>Ksyos verbetert de gezondheid van iedereen.</ChapterTitle>
                            <Paragraph>
                                Ksyos werkt samen met 7.500 huisartsen en 4.500 medisch specialisten en paramedici in
                                Nederland.
                            </Paragraph>
                            <Paragraph>
                                Samen zien we zo’n 2.000 mensen per dag. Dicht bij huis, zonder wachttijd en voor een
                                eerlijke prijs. Van cardiologie en dermatologie tot oogheelkunde, slaap en GGZ: Ksyos
                                maakt de zorg slimmer, beter en menselijker.
                            </Paragraph>
                        </Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}
